import {all} from 'redux-saga/effects'
import {AuthenticationSaga} from './authentication/saga'

export const rootSaga = function* () {
  yield all([AuthenticationSaga()])
}
